/**
 * Q3, CLAUDE.md section 0.5 (Kabir, typed 2026-10-03; "go" on the prompt line
 * 2026-10-11). The one line every model prompt that writes to a customer
 * carries, so the model knows who it writes to. One place, so the wording
 * cannot drift between the reply agent, the shepherd and the review response.
 *
 * It states the rule and never offers one. Single line, no dash of any kind
 * (section 12). Pinned by `icpRuleConstant.test.ts` and
 * `packages/agents/src/icpRulePrompts.test.ts`.
 */
export const ICP_RULE =
  "The customers of this shop are wealthy, serious buyers, so service, craft and attention lead every message. " +
  "Never lead with, offer or volunteer a discount, sale, promo code or deal. " +
  'Answer a customer\'s own price question plainly from the facts, or with "let me check on that".';

/**
 * Fix C3 (sections 0.5 and 4). The variant for a PUBLIC reply (the review
 * response). ICP_RULE's price-question sentence answers a customer's own
 * question from the facts or with "let me check on that"; in public, under a
 * review that mentions price, either is wrong, and the review prompt's next
 * line states no number, date or price. So that sentence is swapped for the
 * public rule: no figure, and anything about an order goes to a private
 * channel. The first two sentences, the no-offer one included, are ICP_RULE's
 * own. ICP_RULE itself is unchanged (pinned to CLAUDE.md 0.5). Pinned by
 * `icpRule.test.ts` and `packages/agents/src/reviewResponseCompose.test.ts`.
 */
export const ICP_RULE_PUBLIC =
  "The customers of this shop are wealthy, serious buyers, so service, craft and attention lead every message. " +
  "Never lead with, offer or volunteer a discount, sale, promo code or deal. " +
  "A public reply states no figure, and invites the customer to write to the shop privately about anything to do with an order.";
